export function createCtx(state, { type, payload }) {
    return {
        state,
        stateNew: {},
        type,
        payload,
        changedIds: [],
    };
}
class SetCounted {
    constructor() {
        this._counter = new Map();
    }
    add(el) {
        this._counter.set(el, (this._counter.get(el) || 0) + 1);
    }
    delete(el) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const count = this._counter.get(el);
        if (count === 1) {
            return this._counter.delete(el);
        }
        if (count > 1) {
            this._counter.set(el, count - 1);
        }
        return false;
    }
    forEach(cb) {
        this._counter.forEach((_, fn) => cb(fn));
    }
}
export class Tree {
    constructor(id, isLeaf = false) {
        this.id = id;
        this.isLeaf = isLeaf;
        this.fnsMap = new Map();
    }
    _getFns(key) {
        return this.fnsMap.get(key) || this.fnsMap.set(key, new SetCounted()).get(key);
    }
    addFn(fn, key) {
        this._getFns(key).add(fn);
    }
    union(tree) {
        tree.fnsMap.forEach((set, key) => {
            const fns = this._getFns(key);
            set.forEach((fn) => fns.add(fn));
        });
    }
    disunion(tree, cb) {
        tree.fnsMap.forEach((set, key) => {
            const fns = this._getFns(key);
            set.forEach((fn) => fns.delete(fn) && cb(fn._ownerAtomId));
        });
    }
    forEach(key, ctx) {
        const setCounted = this.fnsMap.get(key);
        if (setCounted)
            setCounted.forEach((fn) => fn(ctx));
    }
}
